import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const home = () => {
	parallax()
	overlay()
}

const parallax = () => {

	let els = document.querySelectorAll('[data-animation="home-banner-parallax"]')

	if (!els.length || window.innerWidth < 782) return

	els.forEach(el => {

		el.style.opacity = 1

		let perc = el.classList.contains('image') ? 50 : 30

		gsap.fromTo(el, {
			yPercent: 0,
		}, {
			yPercent: perc,
			ease: 'none',
			scrollTrigger: {
				trigger: el.parentElement,
				start: 'top top',
				end: 'bottom top',
				scrub: true,
				// markers: true,
			}
		})
	})
}

const overlay = () => {

	let el = document.querySelector('[data-animation="home-banner-overlay"]')

	if (!el) return

	el.style.opacity = 1

	gsap.fromTo(el, {
		opacity: 0,
	}, {
		opacity: 1,
		scrollTrigger: {
			trigger: el.parentElement,
			start: 'top top',
			end: 'bottom top',
			scrub: true,
			// markers: true,
		}
	})
}

export default () => { }